module.exports = __webpack_public_path__ + "static/media/home_cleaning_settings.20be4476.svg";